const PASSWORD_CASE_REGEX = /^((?=.*\d)|(?=.*[A-Z])|(?=.*\W)).*$/;

function checkCasePresence(text) {
  if (text === "") return;
  return PASSWORD_CASE_REGEX.test(text);
}

export { checkCasePresence };
